<template>
  <div>
    <div id="teachClass_head">
      <el-row>
        <el-col :span="10">
          <span class="grail-left" >
           创建时间：
          </span>
          <div class="grail-main" >
            <pDate class="date" ref="getdate" @query="queryData"></pDate>
          </div>
        </el-col>
        <el-col :span="5">
          <span class="grail-left" >
           课件分类：
          </span>
          <div class="grail-main" >
            <el-select class="select_middle" v-model="courseware" clearable placeholder="全部" >
              <el-option
                  v-for="item in coursewareOptions"
                  :key="item.id"
                  :label="item.catalogName"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="5">
          <span class="grail-left" >
           学科分类：
          </span>
          <div class="grail-main" >
            <el-select class="select_middle" v-model="subject" clearable placeholder="全部" >
              <el-option
                  v-for="item in subjectOptions"
                  :key="item.id"
                  :label="item.catalogName"
                  :value="item.id">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <span class="grail-left" >
            是否公开：
          </span>
          <div class="grail-main" >
            <el-select class="select_middle" v-model="openOption" clearable placeholder="全部" >
              <el-option
                  v-for="item in openOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="10">
          <span class="grail-left" >
            课件名称：
          </span>
          <div class="grail-main" >
            <el-input
              class="select_middle"
              placeholder="请输入关键字"
              v-model="className"
              clearable>
            </el-input>
          </div>

        </el-col>
        <el-col :span="4">
          <el-button class="query-btn" @click="getTime">查询</el-button>
        </el-col>
      </el-row>
    </div>
    <div id="teachClass_body">
      <el-table id="teachClassTable"
        v-loading="loading"
        :data="teachClassTableData"
        style="width: 100%;"
        :height="tableHeight"
        @selection-change = "selectTeachClass"
        stripe
        >
        <el-table-column  type="selection" width="55" ></el-table-column>
        <el-table-column  prop="subject" show-overflow-tooltip min-width="150"  label="课件名称"></el-table-column>
        <el-table-column  prop="creatorName" show-overflow-tooltip min-width="70" label="创建人"></el-table-column>
        <el-table-column  prop="createDateStr" show-overflow-tooltip min-width="150" label="创建时间"></el-table-column>
        <!-- <el-table-column  prop="hosName" show-overflow-tooltip min-width="150" label="所属机构"></el-table-column> -->
        <el-table-column  prop="keywords" show-overflow-tooltip min-width="150" label="关键词"></el-table-column>
        <el-table-column  prop="openFlagName" show-overflow-tooltip min-width="100" label="是否公开"></el-table-column>
        <el-table-column  prop="courseType"   show-overflow-tooltip min-width="100" label="课件分类"></el-table-column>
        <el-table-column  prop="scienceType"   show-overflow-tooltip min-width="100" label="学科分类"></el-table-column>
        <!-- <div slot="empty">
          <img src="../../../../static/images/tableDefult.png" alt="" style="margin-bottom: 50px;" />
        </div> -->
      </el-table>
       <page :total="pageInfo.total" :allPage="pageInfo.allPage" :currentPage="pageInfo.currentPage" @current-page="__currentPage"
            @page-size="__pageSize"></page>
    </div>
    <div class="teachClass_foot">
      <el-button @click="submit(true)" class="submit_button">确定</el-button>
      <el-button @click="submit(false)" class="cencel_button">取消</el-button>
    </div>
  </div>
</template>
<script>
import pDate from '@/components/common/date/selectDate'
import page from '@/components/common/page/page'
import http from '@/api/http'
import * as _ from '@/common/js/config'
export default {
  components:{
    pDate,
    page
  },
  data(){
    return{
      courseware:"",//课件分类
      coursewareOptions:[],//课件分类选项
      subject:"",//学科分类
      subjectOptions:[],//学科分类选项
      openOption:"",//是否公开
      openOptions:[//是否公开选项
        {label:"私人",value:0},
        {label:"公开",value:1}
      ],
      className:"",//课件名称
      teachClassTableData:[],
      loading:false,
      tableHeight:400,
      pageInfo: {
        currentPage: 1,
        pageSize: 30,
        total: 0,
        allPage: 0
      },
      teachClassSelection:[],//被选中的课件选项 存放id
    }
  },
  created() {
    this.getCursetypeList();
    this.getSubjectList();
  },
  mounted() {
    this.$refs.getdate.getDate();
  },
  methods: {
    getCursetypeList() {//获取课件分类
      http.post('/system/getCourseTypes.json').then(res => {
        if (res.data.code === _.ERR_OK) {
          this.coursewareOptions = res.data.model
        } else {
        }
      }).catch(err => {
      })
    },
    getSubjectList() {//获取学科分类
      http.post('/system/getScienceTypes.json').then(res => {
        if (res.data.code === _.ERR_OK) {
          this.subjectOptions = res.data.model
          let itemOne = {
            catalogName: "所有",
            id: ""
          };
          this.subjectList.unshift(itemOne);
        } else {
        }
      }).catch(err => {
      })
    },
    selectTeachClass(selection){
       this.teachClassSelection =[]
      if(selection.length>0){
        selection.forEach(item => {
          this.teachClassSelection.push(item.id);
        });
      }
    },
    getTime() {
        this.$refs.getdate.getDate();
      },
    queryData(emitDate){//查询列表
      const examStartDate = emitDate.fDate,
          examEndDate =emitDate.aDate;

      const params = {
        pageSize: this.pageInfo.pageSize,
        currentPage:  this.pageInfo.currentPage,
        fromFlag:1,//区分是列表调用0还是弹框调用1
      };

      if(examStartDate){
        params.startDateStr = examStartDate;
      }
      if(examEndDate){
        params.endDateStr = examEndDate;
      }
      if(this.openOption !==""){
        params.openFlag = this.openOption;
      }
      if(this.courseware){
        params.courseTypeId = this.courseware;
      }
      if(this.subject){
        params.scienceTypeId = this.subject;
      }
      if(this.className){
        params.keyword = this.className;
      }
      this.loading = true;
      http.post('/materia/queryMeteriaList.json', params).then(res => {
        this.loading = false
        if (res.data.code === _.ERR_OK) {
          const dataList  = res.data.model
          for (let item of dataList) {
            if (item.openFlag === '1') {
              item.openFlagName = '公开'
            } else {
              item.openFlagName = '私人'
            }
          }
          this.teachClassTableData = dataList;
          this.pageInfo.total = res.data.totalItem;
        }
      }).catch(err => {
        // errMsg(err)
      })
    },
    __currentPage(payload) {
      this.pageInfo.currentPage = payload;
      this.getTime();
    },
    __pageSize(payload) {
      this.pageInfo.pageSize = payload;
      this.pageInfo.currentPage=1
       this.getTime();
    },
    submit(val){
       if(val===true) {
        this.$emit( 'teachClassSelect', this.teachClassSelection)
       } else {
        this.$emit( 'teachClassSelectClose', false)
       }
    },
  },
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
  .grail-left
    width: 80px
    height: 36px
    line-height: 36px
    text-align: right
    float: left
  .grail-main
    width: calc( 100% - 80px)
    float: left
    line-height: 36px
  .select_middle
    vertical-align: middle;

  .query-btn
    height: 30px;
    line-height:0px;
    text-align: center;
    border-radius: 3px;
    width: 80px;
    color: #fff !important;
    background: #00abad !important;
    z-inde: 20;
    cursor: pointer;
    float: right;

  .teachClass_foot {
    width: 100%;
    margin-top: 20px;
    height : 100%;
    text-align: center;

    .submit_button {
      background: #00abad;
      width: 220px;
      text-align: center;
      color: #fff !important;
      border-color: transparent;
    }

    .cencel_button {
      background: #aaadb3;
      width: 220px;
      text-align: center;
      border-color: transparent;
      color: #fff !important;
      margin-left: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// teachClassSelection.vue?c7b90722